<div class="grid name-register-grid">
    <div id='name-register-header'>{{trans('auth.titles.enterName')}}</div>
    <div id='name-register-description'>{{trans('auth.activation.nameDescription')}}</div>
    <app-text-edit id='name-form' [value]='userName' (valueChanged)='userName = $event' (enterClicked)='onFinish()' [doFocus]='true'>{{trans('users.labels.nameProfile')}}</app-text-edit>
    <div id='name-register-gologin'>{{trans('auth.alreadyRegistered')}} <span (click)='loginClick()'>{{trans('auth.buttons.logIn')}}</span></div>
</div>